import React, { useState, useEffect } from "react";
import { Avatar, Box, Card, CardContent, Typography } from "@mui/material"; // Import MUI components
import './aboutslider.css'; // Import your CSS file
import image1 from "../../assets/group-people-working-out-business-plan-office.jpg";
import image2 from "../../assets/group-people-working-out-business-plan-office.jpg";
import image3 from "../../assets/group-people-working-out-business-plan-office.jpg";

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array of cards with background images and content
  const cards = [
    { header: "Integrity", content: "We believe in building transparent and honest relationships with our clients." },
    { header: "Excellence", content: "We strive for high-quality results in every project we undertake." },
    { header: "Responsibility", content: "We uphold ethical practices and ensure timely delivery of our services." },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === cards.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [cards.length]);

  return (
    <Box
      className="slider-container"
      sx={{ overflow: "hidden", border: "none" , maxWidth: {
        xs:"300px",
        sm:"100%",
        md:"100%",
        lg:"100%",
        xl:"100%"
       },
         border: "1px solid #0B77A8"
      }}
    >
      <Box
        className="slider-wrapper"
        sx={{
          display: "flex",
          transition: "transform 0.5s ease-in-out",
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {cards.map((item, index) => (
          <Card
            key={index} // Add a unique key for each card
            sx={{
              border: "white",
              minWidth: "100%", // Ensure each card takes full width of the container
              backgroundColor: "rgba(255, 255, 255, 0.5)", // Adjust to desired transparency (white with 50% opacity)
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              flexDirection: "column",
              color: "black", // Set text color to black for better contrast on a light background
              borderRadius: "10px", // Optional: rounded corners
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            
              // Optional: shadow for depth
            }}
          >
            <CardContent>
              <Typography variant="h5" sx={{ fontWeight: "bold", display: "block" }}>
                <Avatar className="poppins-regular" style={{ marginBottom: "10px" }}>{index + 1}</Avatar>
                <Typography component='p' className="poppins-semibold">{item.header}</Typography>
              </Typography>
              <Typography variant="body1" className="poppins-regular" sx={{
                marginTop: "10px", color: "#754414",
                backgroundImage: "linear-gradient(45deg, #754414 61%, #995D27 31%, #A37236 0%, #B0864C 78%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}>
                {item.content}
              </Typography>
            </CardContent>
          </Card>

        ))}
      </Box>
    </Box>
  );
};

export default Slider;
